<template>
  <div class="customer-select-component">
    <dd-select
      placeholder="Zoek een klant"
      v-bind="$attrs"
      :searchable="searchable"
      :allow-clear="false"
      :show-arrow="false"
      @search="searchCustomer"
      :filter-option="() => true"
      v-model="selectedValue"
      :options="customerOptions"
      :mode="multiple ? 'multiple' : 'default'"
      not-found-content="Geen klant(en) gevonden met deze zoekterm."
    >
    </dd-select>
    <input type="hidden" :name="inputName" :value="selectedValue" />
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import customerApi from "~/api/customer";
import customerUtils from "~/util/customer";

export default {
  name: "DdCustomerSelect",
  props: {
    value: {
      type: [String, Number, Array],
      required: false,
    },
    inputName: {
      type: String,
      required: false,
      default: 'customer_id'
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean
    }
  },
  data() {
    return {
      initialCustomers: [],
      searchCustomers: [],
      selectedValue: null,
    };
  },
  mounted() {
    this.searchCustomer = debounce(this.searchCustomer, 600);
    if (!this.value) return;
    this.selectedValue = this.value;
    if (this.multiple) {
      Promise
          .all(this.value.map(value => this.fetchCustomer(value)
          .then(({data}) => data)))
          .then(data => this.initialCustomers = data);
    } else {
      this.fetchCustomer(this.value)
          .then(({data}) => this.initialCustomers = [data]);
    }
  },
  watch: {
    selectedValue() {
      this.$emit("input", this.selectedValue);
    },
    value(newValue) {
      if (newValue === null) {
        this.selectedValue = null;
      }
    },
  },
  computed: {
    customerOptions() {
      return [
        ...this.initialCustomers.map(customer => this.getCustomerOption(customer)),
        ...this.searchCustomers.map(customer => this.getCustomerOption(customer)),
      ].sort((a, _) => {
        return String(a.value) === String(this.selectedValue) || (this.selectedValue && this.selectedValue.includes(String(a.value))) ? -1 : 1
      });
    }
  },
  methods: {
    fetchCustomer(customerId) {
      return customerApi.find(customerId);
    },
    getLabel(customer) {
      return `${customerUtils.getFullName(customer)}${!customer.is_business ? ` - ${customer.age} jaar` : ''}`
    },
    getCustomerOption(customer) {
      return {
        label: this.getLabel(customer),
        value: customer.id,
      };
    },
    searchCustomer(query) {
      if (query.length === 0) {
        return;
      }
      // TODO: fix the customerApi.search call and make use of that, see ticket DD-21283
      // TODO: Call elasticsearch customer api when available.
      // TODO: customerApi.search(query, ['highlight']).then(response => {
      customerApi.searchByName(query, '', 25)
          .then(({data}) => {
            const selectedSearchCustomers = this.getSelectedSearchCustomers(data);
            const newSearchCustomers = data.filter(customer => {
              return !this.initialCustomers.find(initialCustomer => initialCustomer.id === customer.id);
            });
            this.searchCustomers = [...selectedSearchCustomers, ...newSearchCustomers];
          })
    },
    getSelectedSearchCustomers(data) {
      return this.searchCustomers.filter(searchCustomer => {
        const selectedCustomerAlreadyInData = data.find(customer => String(customer.id) === String(searchCustomer.id));
        if (selectedCustomerAlreadyInData) {
          return false;
        }
        return String(searchCustomer.id) === this.selectedValue || (this.selectedValue && this.selectedValue.includes(String(searchCustomer.id)));
      });
    }
  }
}
</script>
